/*
Config knobs:
- src/arcade.ts: REPLAY_MODE (replay a recorded session)
- src/arcade.ts: HEADLESS_BENCHMARK_MODE (run headless sim loop)
- src/arcade.ts: DEBUG_RENDER_FPS (simulate low render FPS, 0 disables)
- src/arcade/replaySession.ts: REPLAY_SESSION (replay data)
- src/sim/constants.ts: ARCADE_SIM_DT_MS (fixed sim step in ms)
*/
import arcade from './arcade';
import { loaders } from 'apollo-e/loader';
import { loadTexture } from 'apollo-e/rendering/Texture';
import { initOpenGameSDK } from './ogpClient';

(async function initializeGame () {
  void initOpenGameSDK();

  // Load all assets in parallel for better performance
  const [
    mplusFont,
    tile,
    particle,
    ground,
    gameLogoBlack,
    // farBg0,
    // happyTechLogo,
    // sheep,
    // gameLogoWhite,
  ] = await Promise.all([
    loaders.loadFont('resources/fonts/mplus.ttf'),
    loadTexture('resources/arcade/tile.png'),
    loadTexture('resources/arcade/particle.png'),
    loadTexture('resources/arcade/ground.png'),
    loadTexture('resources/arcade/logo-black.png'),
    // loadTexture('resources/arcade/far-bg-0.jpg')
    // loadTexture('resources/happy-tech/logo-1.png'),
    // loadTexture('resources/arcade/sheep.png'),
    // loadTexture('resources/arcade/logo-white.png'),
  ]);

  const assets = {
    tile,
    particle,
    ground,
    gameLogoBlack,
    // happyTechLogo,
    fonts: {
      mplus: mplusFont
    },
    // farBg0,
    // sheep,
    // gameLogoWhite,
  };
  
  arcade(assets);
})();
